import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../dashboard/DashboardIcons';

const STATUS_DOT = { upcoming: 'bg-slate-400', active: 'bg-emerald-500', closed: 'bg-slate-300' };

// مبدّل الموسم العام — يظهر بأعلى كل صفحات المنشأة ويحدّد نطاق البيانات المعروضة (لاعبين/فرق/مباريات/حضور/مالية/تقارير)
export const SeasonSwitcher = ({ seasons = [], selectedSeasonId, setSelectedSeasonId }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  if (!seasons.length) return null;

  const current = seasons.find((s) => s.id === selectedSeasonId);
  const label = selectedSeasonId === 'all' ? 'الأرشيف الكامل' : selectedSeasonId === 'unlinked' ? 'غير مرتبطة بموسم' : current?.name || 'اختر موسماً';

  const choose = (val) => { setSelectedSeasonId(val); setOpen(false); };
  const openSeasonSettings = () => { setOpen(false); navigate('/teams?view=seasons'); };

  return (
    <div className="relative" ref={ref} data-testid="season-switcher">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="season-switcher-btn"
        className="group flex h-9 w-9 items-center justify-center gap-1.5 rounded-full text-xs font-bold text-slate-700 transition-all hover:bg-slate-100/80 active:scale-90 sm:h-auto sm:w-auto sm:justify-start sm:gap-2 sm:rounded-xl sm:border sm:border-slate-200/90 sm:bg-white sm:px-3 sm:py-2 sm:shadow-[0_1px_2px_rgba(0,0,0,0.03)] sm:hover:border-teal-300 sm:hover:bg-teal-50"
        title={label}
      >
        <Icon name="calendar" className="h-[17px] w-[17px] shrink-0 text-slate-400 transition-colors group-hover:text-teal-700 sm:h-3.5 sm:w-3.5 sm:text-slate-500" />
        <span className="hidden max-w-[120px] truncate sm:inline sm:max-w-[160px]">{label}</span>
        <Icon name="chevronDown" className={`hidden h-3 w-3 text-slate-400 transition-transform sm:inline-block ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="fixed inset-x-4 top-16 sm:absolute sm:inset-x-auto sm:left-0 sm:top-auto sm:mt-2 w-auto sm:w-64 rounded-2xl border border-slate-200/80 bg-white p-2 shadow-2xl z-50" data-testid="season-switcher-dropdown">
          <div className="flex items-center justify-between px-2 pb-1.5 pt-1">
            <span className="text-[11px] font-bold uppercase tracking-wide text-slate-400">نطاق البيانات</span>
            <button onClick={openSeasonSettings} data-testid="season-switcher-settings-btn" title="إعدادات المواسم" className="rounded-lg p-1 text-slate-400 transition-colors hover:bg-slate-100 hover:text-teal-700">
              <Icon name="cog" className="h-3.5 w-3.5" />
            </button>
          </div>
          <button
            onClick={() => choose('all')}
            data-testid="season-switcher-option-all"
            className={`flex w-full items-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold transition-colors ${selectedSeasonId === 'all' ? 'bg-teal-50 text-teal-800' : 'text-slate-700 hover:bg-slate-50'}`}
          >
            <Icon name="archive" className="h-4 w-4 text-slate-400" /> الأرشيف الكامل (كل المواسم)
          </button>
          <div className="my-1 border-t border-slate-100" />
          {seasons.map((s) => (
            <button
              key={s.id}
              onClick={() => choose(s.id)}
              data-testid="season-switcher-option"
              className={`flex w-full items-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold transition-colors ${selectedSeasonId === s.id ? 'bg-teal-50 text-teal-800' : 'text-slate-700 hover:bg-slate-50'}`}
            >
              <span className={`h-2 w-2 shrink-0 rounded-full ${STATUS_DOT[s.status] || 'bg-slate-300'}`} />
              <span className="flex-1 truncate text-right">{s.name}</span>
              {s.status === 'active' && <span className="shrink-0 rounded-full bg-emerald-50 px-1.5 py-0.5 text-[10px] font-bold text-emerald-700">نشط</span>}
            </button>
          ))}
          <div className="my-1 border-t border-slate-100" />
          <button
            onClick={() => choose('unlinked')}
            data-testid="season-switcher-option-unlinked"
            className={`flex w-full items-center gap-2 rounded-xl px-3 py-2 text-sm font-semibold transition-colors ${selectedSeasonId === 'unlinked' ? 'bg-teal-50 text-teal-800' : 'text-slate-700 hover:bg-slate-50'}`}
          >
            <Icon name="clock" className="h-4 w-4 text-slate-400" /> غير مرتبطة بموسم
          </button>
        </div>
      )}
    </div>
  );
};

export default SeasonSwitcher;
